// PostTypeTabs.js
// Save this file as: src/components/PostTypeTabs.js

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PostTypeTabs = ({
  activeTab,
  selectedGroups,
  showEventTab,
  isEditing,
  isGroupDisabledForEvents,
  eventsDisabledLoaded = true, // ✅ NEW
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const shouldRenderEventTab = showEventTab || activeTab === "event";

  // ✅ Block if: check is still pending (only when a group is selected) OR group is disabled
  const eventTabBlocked =
    (selectedGroups?.length > 0 && !eventsDisabledLoaded) ||
    isGroupDisabledForEvents;
  console.log(
    "isGroupDisabledForEvents",
    isGroupDisabledForEvents,
    "eventsDisabledLoaded",
    eventsDisabledLoaded,
  );
  console.log("event tab Blovked: ", eventTabBlocked);

  const handleTabClick = (tab) => {
    if (eventTabBlocked && tab === "event") return; // ✅ block click
    if (tab === "event" && selectedGroups && selectedGroups.length === 1) {
      navigate(`/group/${selectedGroups[0]}/events/create`, {
        replace: true,
        state: location.state,
      });
    } else if (tab === "standard") {
      navigate(`/post/create`, { replace: true, state: location.state });
    } else if (tab === "carousel") {
      navigate(`/carousel-post/create`, { replace: true, state: location.state });
    }
  };

  return (
    <div className="m-auto flex w-5/6 justify-center gap-0 mt-4 border-b border-gray-300">
      {!isEditing && (
        <>
          <button
            type="button"
            className={`flex-1 px-4 py-3 text-center bg-white font-medium transition-colors ${activeTab === "standard"
              ? "text-gray-700 border-b-2 border-teal-500"
              : "text-gray-500 hover:text-gray-700"
              }`}
            style={activeTab === "standard" ? { borderBottomWidth: "3px" } : {}}
            onClick={() => handleTabClick("standard")}
          >
            Standard Post
          </button>
          <button
            type="button"
            className={`flex-1 px-4 py-3 text-center bg-white font-medium transition-colors ${activeTab === "carousel"
              ? "text-gray-700 border-b-2 border-teal-500"
              : "text-gray-500 hover:text-gray-700"
              }`}
            style={activeTab === "carousel" ? { borderBottomWidth: "3px" } : {}}
            onClick={() => handleTabClick("carousel")}
          >
            Carousel Post
          </button></>
      )}

      {shouldRenderEventTab && <button
        type="button"
        disabled={eventTabBlocked} // ✅ disabled until loaded AND not disabled
        className={`flex-1 px-4 py-3 text-center bg-white font-medium transition-colors ${eventTabBlocked
          ? "text-gray-300 cursor-not-allowed bg-gray-50"
          : activeTab === "event"
            ? "text-gray-700 border-b-2 border-teal-500"
            : "text-gray-500 hover:text-gray-700"
          }`}
        style={
          activeTab === "event" && !eventTabBlocked
            ? { borderBottomWidth: "3px" }
            : {}
        }
        onClick={() => handleTabClick("event")}
      >
        Event Post
      </button>}
    </div>
  );
};

export default PostTypeTabs;
